import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet, useLocation } from 'react-router-dom';
import { EventEmitter } from '../../utils/EventEmitter';
import AppNavbar from './AppNavbar';
import AppSidebar from './AppSidebar';
import { Flex, FloatButton } from 'antd';
import AppChat from './AppChat';
import { Col } from 'react-bootstrap';

const titlePrefix = window.__env.APP_TITLE_PREFIX || "Alida - ";

export default function AppLayout() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  const [showChat, setShowChat] = useState(false);
  const [timestamp, setTimestamp] = useState(new Date().getTime());

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const openChat = () => setShowChat(true);
  const handleChatClose = () => setShowChat(false);

  useEffect(() => {
    EventEmitter.subscribe('update-timestamp', (ts: number) => setTimestamp(ts));
  }, []);

  return (
    <main className="app-root">
      <Helmet titleTemplate={`${titlePrefix}%s`}>
        <link rel="stylesheet" href={`${window.__env.OVERRIDES_CSS}?t=${timestamp}`} />
        <script src={`${window.__env.OVERRIDES_JS}?t=${timestamp}`} />
      </Helmet>

      {pathname === '/login'
        ? <Outlet />
        : (
          <>
            <AppNavbar showSidebar={handleShow} />
            <AppSidebar show={show} handleClose={handleClose} />

            <div className="full-viewport">
              <Flex>
                {/* oveflow-hidden to solve graphic bug with scrollable content (tags-wrapper) */}
                <Col className="overflow-hidden">
                  <Outlet />
                </Col>

                <AppChat show={showChat} onClose={handleChatClose} />
              </Flex>
            </div>

            {!showChat && (
              <FloatButton
                onClick={openChat}
                tooltip="Open AI Chat"
                className="ai-glow"
                icon={
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
                  </svg>
                }
              />
            )}
          </>
        )}
    </main>
  )
}